// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2EFmQ","right":"Footer_right__1On9F","buttons":"Footer_buttons__3slY4"};